import { BarChartCard } from "@/components/atoms";
import Grid from "@mui/material/Grid2";
import { InsightResult } from "@/types";
import React from "react";
import { demographics as demographicSections } from "@/utils";
import { sortBy } from "lodash";
import { useInsightFilters } from "@/context";

interface DemographicsViewProps {
  demographics: InsightResult[];
}

export const DemographicsView: React.FC<DemographicsViewProps> = ({
  demographics,
}) => {
  const {
    filters: { scoreType },
  } = useInsightFilters();

  return (
    <Grid container size={12} spacing={2}>
      {demographicSections.map((section, index) => {
        const variables = demographics.filter(
          (x) => x.tag_category === section,
        );
        return (
          <Grid size={{ xs: 12, md: 6, xl: 4 }} key={`demographic-${index}`}>
            <BarChartCard
              title={section}
              variables={sortBy(variables, "rank")}
              score={scoreType.value}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default DemographicsView;
